module.exports = __webpack_public_path__ + "static/2front-branding-1-7f9b55135f0d29fd0315077157ea5277.png";